import { z } from "zod";

// Contract v1: cron 5 trường số, list/range/step; không macro, giây, tên tháng hoặc TZ inline.
// Không tính next occurrence ở contracts. E.4 cần scheduler + DST/misfire tests riêng.
export function validCronExpression(expression: string): boolean {
  const fields = expression.split(" ");
  if (fields.length !== 5) return false;
  const limits = [[0, 59], [0, 23], [1, 31], [1, 12], [0, 6]] as const;
  for (const [index, field] of fields.entries()) {
    const [min, max] = limits[index]!;
    for (const part of field.split(",")) {
      const segments = part.split("/");
      if (segments.length > 2) return false;
      const range = segments[0]!;
      if (segments.length === 2) {
        const step = segments[1]!;
        if (!/^[1-9][0-9]*$/.test(step) || Number(step) > max - min + 1 || (range !== "*" && !range.includes("-"))) return false;
      }
      if (range === "*") continue;
      if (!/^(0|[1-9][0-9]*)(-(0|[1-9][0-9]*))?$/.test(range)) return false;
      const bounds = range.split("-").map(Number);
      if (bounds.some(n => n < min || n > max) || (bounds.length === 2 && bounds[0]! > bounds[1]!)) return false;
    }
  }
  // Không mơ hồ AND/OR giữa day-of-month và day-of-week trong v1.
  return fields[2] === "*" || fields[4] === "*";
}

export const CronExpression = z.string().min(9).max(120).refine(validCronExpression, "INVALID_CRON_EXPRESSION");
export const TimeZone = z.string().min(1).max(80).refine(value => {
  try { new Intl.DateTimeFormat("en", { timeZone: value }); return true; }
  catch (error) { if (error instanceof RangeError) return false; throw error; }
}, "INVALID_TIMEZONE");
